export default "__VITE_ASSET__C7MW$C4y__"